module.exports = __webpack_public_path__ + "static/media/signUp.d2f70869.svg";